import React, { useEffect, useState } from 'react';
import "../../assets/css/general/topBar.css";

const TopBar = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onScroll = () => setHidden(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`home-top-top-bar ${hidden ? 'home-top-hidden' : ''}`}>
      <div className="home-top-top-bar-container">
        <div className="home-top-contact-info">
          <span><i className="fas fa-envelope"></i> info@journeyjunction.com</span>
          <span className="home-top-phone-gap"><i className="fas fa-phone"></i> +92 300 1234567</span>
        </div>
        <div className="home-top-social-links">
          <span>Follow Us:</span>
          <a href="#" title="tiktok"><i className="fab fa-tiktok"></i></a>
          <a href="#" title="Instagram"><i className="fab fa-instagram"></i></a>
          <a href="#" title="YouTube"><i className="fab fa-youtube"></i></a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;